import './SearchCustomIndicator.css';

import React, { useContext } from 'react';
import IndicatorsSearchForm from '../../../b2b-indicators/components/IndicatorsSearchForm';
import { fetchCustomIndicatorsData } from '../../../../services/b2b-indicators-apiService';
import B2BElementsExplorer from '../../../b2b-common/B2BElementsExplorer';
import { SelectIndicatorContext } from '../../pages/AreaIndicatorEditPage';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import SelectableIndicatorCard from '../../../b2b-indicators/components/SelectableIndicatorCard';

const SearchCustomIndicator = ({ onSelectedCustomIndicator }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const { customIndicators, setCustomIndicators } = useContext(SelectIndicatorContext);

    const handlePageChange = (event, value) => {
        setCustomIndicators(prevState => ({
            ...prevState,
            currentPage: value,
            refresh: true
        }));
    };

    const handleSelectedCustomIndicator = (indicator) => {
        //console.log('handleSelectedCustomIndicator: ', indicator);
        // setRefresh(false);
        onSelectedCustomIndicator && onSelectedCustomIndicator(indicator);
    }

    return (
        <div className='search-custom-indicator'>
            <IndicatorsSearchForm
                title={t('Custom indicators search form')}
                currentPage={customIndicators.currentPage}
                setCurrentPage={(page) => setCustomIndicators(prevState => ({ ...prevState, currentPage: page }))}
                refresh={customIndicators.refresh}
                setRefresh={(refresh) => setCustomIndicators(prevState => ({ ...prevState, refresh }))}
                isSearching={customIndicators.isSearching}
                setIsSearching={(isSearching) => setCustomIndicators(prevState => ({ ...prevState, isSearching }))}
                searchFunction={fetchCustomIndicatorsData}
                setIndicatorsData={(data) => setCustomIndicators(prevState => ({ ...prevState, data }))}
                setPagesCount={(count) => setCustomIndicators(prevState => ({ ...prevState, pagesCount: count }))}
            />
            <B2BElementsExplorer
                title={t('Custom indicators results')}
                isSearching={customIndicators.isSearching}
                elementsData={customIndicators.data}
                pagesCount={customIndicators.pagesCount}
                currentPage={customIndicators.currentPage}
                handlePageChange={handlePageChange}
                pageNumberLoading={customIndicators.pageNumberLoading}
                className="custom-indicators-explorer"
                ElementComponent={SelectableIndicatorCard}
                elementComponentPropName="indicator"
                otherComponentProps={{
                    className: 'custom-indicator-card b2b-indicator-theme-light-01',
                }}
                elementComponentHandlers={{
                    onSelect: handleSelectedCustomIndicator,
                }}
            />
        </div>
    );
};

export default SearchCustomIndicator;